import Resource from '@/api/resources/Resource'
import { CancellationReasonResponse } from '@/api/resources/common/cancellation-reason-services/cancellationReasonServices.models'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CancellationReasonServices extends Resource {
    async getSubportionCancellationReasons(): Promise<CancellationReasonResponse[]> {
        const response = await this.axios.get(`/cancellationReasons/subportionCancellationReasons`)
        return response.data
    }
    async getPortionCancellationReasons(): Promise<CancellationReasonResponse[]> {
        const response = await this.axios.get(`/cancellationReasons/portionCancellationReasons`)
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }
}

export default new CancellationReasonServices()
